import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { PlatformService } from '@panamax/app-state';

export type SimpleSearchModel = {
  searchText?: string;
  isExecuteSearch?: boolean;
};

@Component({
  selector: 'app-new-search-simple-modal',
  templateUrl: './new-search-simple-modal.component.html',
  styleUrls: ['./new-search-simple-modal.component.scss'],
})
export class NewSearchSimpleModalComponent {
  @ViewChild('simpleSearchModalRef') ref: any;
  @Input() isOpen: boolean;
  inputText: string;
  @Output() executeSearchEmitter: EventEmitter<SimpleSearchModel> =
    new EventEmitter();

  constructor(readonly platformService: PlatformService) {}

  handleInputChange(event: any) {
    this.inputText = event?.target?.value?.trim();
  }
  executeSearch() {
    this.ref?.dismiss(true);
  }

  onDismiss(event) {
    if (event?.detail?.data) {
      this.executeSearchEmitter.emit({
        isExecuteSearch: true,
        searchText: this.inputText,
      });
    } else {
      this.executeSearchEmitter.emit({ isExecuteSearch: false });
    }
    this.clearValues();
  }

  onClose() {
    this.ref?.dismiss(false);
  }

  clearValues() {
    this.inputText = '';
  }
}
